<template>
    <div id="app">
        <Loading v-if="isLoading" />
        <div v-if="kioskObj">
            <LangSwitch :lang="locale" @change:lang="locale = $event" />
            <Map
                ref="map"
                :kiosk="kioskObj"
                :objetsTouristiques="objetsTouristiques"
                :objetTouristique="displayedObjetTouristique"
                @marker:click="onMarkerClick"
                @map:initialized="onMapInitialized"
            />
            <FilterPanel
                ref="filtersPanel"
                :selections="selections"
                @selections:change="onSelectionsChange"
                @filters:toggle="onToggleFilters"
            />
            <InfoPanel
                :objetTouristique="displayedObjetTouristique"
                @panel:close="displayedObjetTouristique = null"
            />
        </div>
    </div>
</template>

<script>

/* KIOSK
----------------------------------------------------------------------------------------------------*/

import Map from './components/Map/Map.vue'
import FilterPanel from './components/SelectionsFilter/FilterPanel.vue'
import InfoPanel from './components/ObjetTouristique/InfoPanel.vue'
import LangSwitch from './components/LangSwitch/LangSwitcher.vue'
import Loading from './components/UI/Loading.vue'
import idle from '../utils/idle'

export default {
    name: 'App',

    components: {
        Map,
        FilterPanel,
        InfoPanel,
        LangSwitch,
        Loading,
    },

    data() {
        return {
            objetsTouristiques: [],
            selections: {},
            kioskObj: null,
            displayedObjetTouristique: null,
            locale: 'fr',
            isLoading: true,
            startedTime: Date.now(),
        }
    },

    created() {
        idle(60000, 10000, this.idleHandler)
    },

    mounted() {
        fetch(`/api/kiosk?lng=${this.locale}`)
            .then(response => response.json())
            .then((result) => {
                this.kioskObj = result
            })
    },

    watch: {
        displayedObjetTouristique(obj) {
            if (obj) {
                // Hide all pin when info panel is open, except selected one
                this.objetsTouristiques.forEach((element) => {
                    if (element.id !== obj.id) {
                        element.isVisible = false
                    }
                })
                // Send gtag event
                if (window.gtag) {
                    window.gtag('event', 'objectTouristique_viewed', {
                        event_category: 'view',
                        event_label: obj.id,
                    })
                }
            } else {
                // Show previously shown pin when info panel is closed
                this.objetsTouristiques.forEach((element) => {
                    element.isVisible = this.$refs.filtersPanel.getSelectionIds().indexOf(element.selectionId) > -1
                })
            }
        },

        locale() {
            this.reset()
            this.fetchObjetsTouristiques()
            this.$root.trans = this.$root.alltrans[this.locale]
        },
    },

    methods: {
        onMapInitialized() {
            this.fetchObjetsTouristiques()
        },

        onSelectionsChange(selectionsIds) {
            this.objetsTouristiques.forEach((element) => {
                element.isVisible = selectionsIds.indexOf(element.selectionId) > -1
            })
            // wait to avoid bug on cluster rebuild
            setTimeout(() => {
                this.$refs.map.reset()
            }, 500)
        },

        onMarkerClick(objetTouristique) {
            this.displayedObjetTouristique = objetTouristique
        },

        onToggleFilters(isOpen) {
            if (isOpen) {
                this.displayedObjetTouristique = null
            }
        },

        fetchObjetsTouristiques() {
            this.isLoading = true
            fetch(`/api/get?lng=${this.locale}`)
                .then(response => response.json())
                .then((result) => {
                    this.objetsTouristiques = result.objetsTouristiques.map((obj) => {
                        obj.isVisible = true
                        return obj
                    })
                    this.selections = result.selections
                    this.isLoading = false
                })
        },

        idleHandler() {
            // Check if app is running for more the 1 hour
            const shouldReloadApp = (Date.now() - this.startedTime) > 3600000
            if (shouldReloadApp) {
                // If yes, full reload of the page
                window.location.reload(true)
            } else {
                // If not, just reset state
                this.reset()
            }
        },

        reset() {
            this.displayedObjetTouristique = null
            this.$refs.filtersPanel.isOpen = false
            this.$refs.filtersPanel.reset()
            // filter panel reset, also reset map (in method onSelectionsChange)
        },
    },
}
</script>
